<!--
트래킹번호 수정 컴포넌트
------------------------------------
-->
<template>
    <div :class="classObject">
        <div class="uk-flex uk-flex-middle">
            <!-- TASK-107 #6: 트럭(local_shipping) 아이콘 삭제 / #5: placeholder 변경 / #7: 테두리 표준 블루 -->
            <input class="uk-width-expand uk-text-middle" type="text" v-model.trim="inputTrackingNo" @keyup.enter="submit"
                   style="border: 1px solid #1e87f0;"
                   placeholder="트래킹번호: 하이픈(-)/특수문자/Space 입력 금지"/>
            <button class="uk-button uk-button-small uk-button-dg-w-dg" @click="submit" v-if="edited">입력</button>
            <i class="material-icons md-24 check" v-if="saved && edited === false">check</i>

            <!-- 복사하기 -->
            <copy class="ml-2" tooltip="트래킹 복사하기" :copy-text="oldTrackingNo"></copy>
        </div>

        <!-- 트래킹조회 버튼 -->
        <div v-show="trackingLink" class="tracking-link">
            <a class='uk-button uk-button-xsmall bg-stone-700 text-white p-1' :href="trackingLink" target='_blank'>트래킹조회</a>
        </div>

    </div>


</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // prodId
            prodId: Number,

            // trackingNo
            trackingNo: String,

            // 트래킹조회 기본링크 :url 이 치환단어로 포함된 링크
            basedLink: String,
        },
        data: function () {
            return {
                /**
                 * (string) 수정전 원본값
                 */
                oldTrackingNo: this.trackingNo,

                /**
                 * (string) 입력값
                 */
                inputTrackingNo: this.trackingNo,

                /**
                 * (bool) 저장완료여부
                 */
                saved: false,

            };
        },
        computed: {
            /**
             * 수정여부
             * @return boolean
             */
            edited() {
                return this.oldTrackingNo !== this.inputTrackingNo;
            },

            /**
             * 컴포넌트 전체에 대한 css 클래스
             *  @return Object
             */
            classObject()
            {
                return {
                    // 변경되었음
                    'edited': this.edited,
                    // 저장되었음
                    'saved': this.saved,
                };
            },

            /**
             * 트래킹조회링크
             * @returns {string}
             */
            trackingLink() {
                if (! this.inputTrackingNo) {
                    return null;
                }
                return _.replace(this.basedLink, ':url', this.inputTrackingNo);
            },
        },
        methods: {


            /**
             * submit
             */
            submit() {
                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/'+this.prodId+'/tracking-no',
                        data: {
                            _token: this.csrfToken,
                            tracking_no: this.inputTrackingNo,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    this.oldTrackingNo = this.inputTrackingNo;
                    this.saved = true;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mark {
        margin-right: 2px;

    }
    input {
        font-size: 0.875rem;
        padding: 1px;
        height: 1.75rem;
    }
    button {
        font-size: 0.875rem;
        padding: 1px;
        height: 1.75rem;
        line-height: 1.75rem;
    }


    // 저장됨
    .saved {
        .mark {
            color: mediumseagreen !important;
        }
        input {
            border: 1px solid mediumseagreen !important;
        }
    }

    // 수정됨
    .edited {
        .mark {
            color: red !important;
        }
        input {
            border: 1px solid red !important;
        }
        button {
            border: 1px solid red !important;
            color: red !important;
        }
    }

    .check {
        color: mediumseagreen !important;
    }

    /* TASK-161 사이클 12 §3-2: 18px 들여쓰기 삭제 — 버튼을 input 왼쪽 선에 정렬 (배송조회·카드 공통) */
    .tracking-link {
        margin-left: 0;
    }
</style>